import React, { useEffect } from "react";
import { Drawer, Box, Typography, Divider, Button } from "@mui/material";
import { CatalogItem } from "./catalog.component";
import noImage from '../../../assets/img/no_image.jpg';
import { api } from "../../../config/apiCaller.config";
import Swal from "sweetalert2";
import { useWallet } from "../../../hooks/useWallet.hook";

interface RedemptionProps {
    selectedReward: CatalogItem | undefined;
    setSelectedReward: (reward: CatalogItem | undefined) => void;
}

const RedemptionModal: React.FC<RedemptionProps> = ({ selectedReward, setSelectedReward }: RedemptionProps) => {

    const { loadWallet } = useWallet();
    const [isDrawerOpen, setIsDrawerOpen] = React.useState(false);

    useEffect(() => {
        if (selectedReward) {
            setIsDrawerOpen(true);
        }
    }, [selectedReward]);

    const handleCloseDrawer = () => {
        setIsDrawerOpen(false);
        setSelectedReward(undefined);

    }

    const handleConfirmRedemption = async () => {
        if (!selectedReward) {
            handleCloseDrawer();
            return;
        }

        Swal.fire('Aguarde', 'Estamos processando seu resgate');
        Swal.showLoading();

        try {
            const response = await api.post(`/redemptions`, { items: [selectedReward._id] });
            
            if (response.status === 201) {
                loadWallet();
                Swal.fire('Sucesso', 'Prêmio resgatado com sucesso', 'success');
            }
        } catch (error: any) {
            if (error.response.status === 400 && error.response.data.message === 'Insufficient points') {
                Swal.fire('', 'Você não possui pontos suficientes para efetuar este resgate', 'warning');
            } else {
                Swal.fire('', error.response.data.message, 'warning');
            }
        }

        handleCloseDrawer();
        setSelectedReward(undefined);
    }

    return (
        <Drawer anchor="right" open={isDrawerOpen} onClose={handleCloseDrawer}>
            <Box width={350} p={3} display="flex" flexDirection="column">
                <Typography variant="h5">Detalhes do Prêmio</Typography>
                <Divider sx={{ my: 2 }} />

                {selectedReward ? (
                    <>
                        <Typography variant="h6">{selectedReward.name}</Typography>

                        {selectedReward.medias?.length && selectedReward.medias.map((media) => (
                            <img 
                                src={`http://${process.env.REACT_APP_API_URL}/rewards/image/${media}`} 
                                onError={(e: any) => {
                                    e.target.src = noImage;
                                }} 
                                alt="Imagem do prêmio" />
                        ))}

                        <Typography variant="body1" color="textSecondary">
                            {selectedReward.description}
                        </Typography>
                        <Typography variant="body2" color="primary">
                            Pontos necessários: {selectedReward.points}
                        </Typography>

                        <Box display="flex" justifyContent="space-between" mt={3}>
                            <Button variant="contained" color="error" onClick={handleCloseDrawer}>
                                Cancelar
                            </Button>
                            <Button style={{backgroundColor: '#D89274'}} variant="contained" color="primary" onClick={handleConfirmRedemption}>
                                Resgatar
                            </Button>
                        </Box>
                    </>
                ) : (
                    <Typography>Carregando...</Typography>
                )}
            </Box>
        </Drawer>
    )

}

export default RedemptionModal;